/**
 * article.js — Progression de lecture et sommaire ancré.
 */

(() => {
  'use strict';

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  const slugify = (text) =>
    text
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const setupProgress = () => {
    const bar = document.querySelector('[data-reading-progress]');
    const root = document.querySelector('[data-article-root]') || document.querySelector('[data-article-body]');
    if (!bar || !root) return;

    const update = () => {
      const rect = root.getBoundingClientRect();
      const start = window.scrollY + rect.top;
      const end = start + root.offsetHeight - window.innerHeight;
      const progress =
        end <= start ? (window.scrollY >= start ? 1 : 0) : Math.min(1, Math.max(0, (window.scrollY - start) / (end - start)));

      bar.style.transform = `scaleX(${progress})`;
      bar.setAttribute('aria-valuenow', String(Math.round(progress * 100)));
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };

  const setupToc = () => {
    const layout = document.querySelector('[data-guide-layout]');
    const toc = document.querySelector('[data-article-toc]');
    const body = document.querySelector('[data-article-body]');
    if (!toc || !body) return;

    const headings = [...body.querySelectorAll('h2')];
    if (!headings.length) {
      toc.hidden = true;
      layout?.classList.remove('has-toc');
      return;
    }

    const list = toc.querySelector('[data-toc-list]');
    if (!list) return;
    list.replaceChildren();

    const usedIds = new Set();

    headings.forEach((heading, index) => {
      if (!heading.id) {
        let base = slugify(heading.textContent || '') || `section-${index + 1}`;
        let id = base;
        let n = 2;
        while (usedIds.has(id) || document.getElementById(id)) {
          id = `${base}-${n}`;
          n += 1;
        }
        heading.id = id;
      }
      usedIds.add(heading.id);

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', (event) => {
        event.preventDefault();
        if (window.LMH?.scrollToTarget) {
          window.LMH.scrollToTarget(heading);
        } else {
          heading.scrollIntoView({
            behavior: reduce.matches ? 'auto' : 'smooth',
            block: 'start',
          });
        }
        history.replaceState(null, '', `#${heading.id}`);
      });
      item.appendChild(link);
      list.appendChild(item);
    });

    toc.hidden = false;
    layout?.classList.add('has-toc');

    const links = [...list.querySelectorAll('a')];
    const setCurrent = (id) => {
      links.forEach((link) => {
        if (link.getAttribute('href') === `#${id}`) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible[0]) setCurrent(visible[0].target.id);
      },
      { rootMargin: '-20% 0px -65% 0px', threshold: 0 }
    );

    headings.forEach((heading) => observer.observe(heading));
  };

  setupProgress();
  setupToc();
})();
